import type { FC, ReactElement, ReactNode } from "react";

import type { OptionItem } from "@/api/admin";
import type { StatusVariants, SubMenuConfig } from "@/components/molecules";

export type MenuItemDropDown = {
  title?: string;
  svg?: ReactElement;
  path?: string;
  dialog?: ReactElement;
  from?: string;
  onClick?: () => void;
};

export type ColumnConfig<T> = {
  key: keyof T;
  label: string;
  visible: boolean;
  headerComponent: FC<{ label: string }>;
  cellRenderer: (row: T, isLast: boolean, className?: string) => ReactNode;
  footerRenderer?: () => ReactNode;
};

export type FilterConfig = {
  props: {
    menuList?: string[];
    subMenus?: Record<string, string[]>;
    subMenuRegistry?: Record<string, SubMenuConfig>;
    statusVariant?: StatusVariants;
    classes?: string;
  };
  children?: ReactNode;
};

export type ViewType = "list" | "calendar";

export const isOptionItem = (v: unknown): v is OptionItem => {
  return typeof v === "object" && v !== null && "id" in v;
};
